;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNumberOfSessions = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "NumberOfSessions_svg__a",
  width: 26,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h25.588v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#NumberOfSessions_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BDBBBB",
  d: "m9.596 20-1.493-1.4 1.866-1.8q-3.413-.425-5.624-1.75Q2.132 13.725 2.132 12q0-2.075 3.079-3.537Q8.289 7 12.794 7q4.504 0 7.583 1.463T23.456 12q0 1.55-1.773 2.775T17.06 16.6v-2.05q2.051-.5 3.158-1.238 1.107-.737 1.107-1.312 0-.8-2.28-1.9Q16.767 9 12.795 9t-6.25 1.1q-2.28 1.1-2.28 1.9 0 .6 1.36 1.438 1.36.837 3.865 1.262l-1.386-1.3L9.596 12l4.264 4z"
}))));
export default SvgNumberOfSessions;